import React, { useMemo, useState } from "react";
import { Drawer, Dropdown } from "antd";
import { connect } from "react-redux";
import Logo from "../../assets/icons/logo.webp";
import "./topbar.scss";
import { useNavigate, useLocation } from "react-router-dom";
import LoginModal from "./LoginModal";
import SvgHamburger from "../../icons/SvgHamburger";
import avatar from "../../assets/svgs/avatar.svg";
import closeIcon from "../../assets/svgs/w-close-icon.svg";
import rightArrow from "../../assets/svgs/arrow-chevron-down.svg";
import downArrow from "../../assets/svgs/arrow-down.svg";
import { scrollTop } from "../../utils/util";
import SvgConsultWithAstrologers from "../../icons/SvgConsultWithAstrologers";
import SvgOurInsights from "../../icons/SvgOurInsights";
import SvgAbout from "../../icons/SvgAbout";
import SvgHome from "../../icons/SvgHome";
import SvgBlogs from "../../icons/SvgBlogs";
import SvgLogout from "../../icons/SvgLogout";
import SvgKidsKundali from "../../icons/SvgKidsKundali";
import SvgEditProfile from "../../icons/SvgEditProfile";
import SvgWallet from "../../icons/SvgWallet";
import SvgNotifications from "../../icons/SvgNotifications";
import SvgDeleteAccount from "../../icons/SvgDeleteAccount";

const mapStateToProps = (state) => {
  const { profileReducers } = state;
  return {
    profileDetails: profileReducers.profileDetails,
  };
};

const InsightsList = [
  {
    id: 1,
    label: "Horoscope",
    path: "/horoscope",
  },
  // {
  //   id: 3,
  //   label: "Predictions Videos",
  //   path: "/videos",
  // },
  {
    id: 4,
    label: "Games",
    path: "/games",
  },
  {
    id: 2,
    label: "Compatibility",
    path: "/compactibility",
  },
];

const TopBar = ({ handleReset, profileDetails }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const location = useLocation();
  const [loginModalVisible, setloginModalVisible] = useState(false);
  const [menuList, setMenuList] = useState(false);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const getUserData = localStorage.getItem("user");

  const items = useMemo(() => {
    return [
      {
        id: 0,
        label: "Edit Profile",
        icon: (
          <img
            alt="edit"
            src={require("../../assets/svgs/profile-user-edit.svg").default}
          />
        ),
        click: () => {
          navigate("/edit-profile");
        },
        active: window.location.hash === "#/edit-profile",
      },
      {
        id: 1,
        label: "Notifications",
        icon: (
          <img
            alt="notification"
            src={require("../../assets/svgs/profile-notification.svg").default}
          />
        ),
        click: () => {
          navigate("/notifications");
        },
        active: window.location.hash === "#/notifications",
      },
      {
        id: 2,
        label: "Wallet",
        icon: (
          <img
            alt="wallet"
            src={require("../../assets/svgs/profile-wallet.svg").default}
          />
        ),
        click: () => {
          navigate("/wallet");
        },
        active: window.location.hash === "#/wallet",
      },
      {
        id: 3,
        label: "Delete Account",
        icon: (
          <img
            alt="delete"
            src={
              require("../../assets/svgs/profile-account-delete.svg").default
            }
          />
        ),
        click: () => {
          navigate("/delete-account");
        },
        active: window.location.hash === "#/delete-account",
      },
      {
        id: 3,
        label: "Logout",
        icon: (
          <img
            alt="logout"
            src={require("../../assets/svgs/svg-logout.svg").default}
          />
        ),
        click: () => {
          localStorage.clear();
          navigate("/");
        },
        active: false,
      },
    ];
  }, []);

  return (
    <>
      {loginModalVisible && (
        <LoginModal
          open={loginModalVisible}
          onHide={() => setloginModalVisible(false)}
        />
      )}
      <nav className="navbar-container">
        <div className="navbar">
          <div>
            <img
              src={Logo}
              alt="Logo"
              className="logo cursor_pointer"
              onClick={() => {
                if (handleReset) {
                  handleReset();
                }
                navigate("/");
              }}
            />
          </div>
          <div className={`menu-visible`}>
            <ul className="menu-list">
              <li
                onClick={() => {
                  navigate("/");
                  if (handleReset) {
                    handleReset();
                  }
                }}
                className={
                  location.pathname === "/" ||
                  location.pathname === "/ask-question"
                    ? "active"
                    : ""
                }
              >
                Home
              </li>
              <li
                onClick={() => {
                  navigate("/about");
                  if (handleReset) {
                    handleReset();
                  }
                }}
                className={location.pathname === "/about" ? "active" : ""}
              >
                About
              </li>
              <li>
                <Dropdown
                  dropdownRender={() => {
                    return (
                      <div className="menuDrop insights-dropdown">
                        {InsightsList.map((list) => {
                          return (
                            <span
                              onClick={() => {
                                navigate(list.path);
                                if (handleReset) {
                                  handleReset();
                                }
                              }}
                              key={list.id}
                            >
                              {list.label}
                            </span>
                          );
                        })}
                      </div>
                    );
                  }}
                  overlayStyle={{ backgroundColor: "#060113" }}
                  menu={{ InsightsList }}
                >
                  <div> Our Insights</div>
                </Dropdown>
              </li>

              <li
                onClick={() => {
                  navigate("/blogs");
                  if (handleReset) {
                    handleReset();
                  }
                }}
                className={location.pathname.includes("/blogs") ? "active" : ""}
              >
                Blogs
              </li>
              <li
                onClick={() => {
                  navigate("/consult-astrology");
                  if (handleReset) {
                    handleReset();
                  }
                }}
                className={
                  location.pathname === "/consult-astrology" ||
                  location.pathname === "/astrologer-details"
                    ? "active"
                    : ""
                }
              >
                Consult With Astrologers
              </li>
              <li
                onClick={() => {
                  navigate("/kundali");
                  if (handleReset) {
                    handleReset();
                  }
                }}
                className={location.pathname === "/kundali" ? "active" : ""}
              >
                Kids Kundli
              </li>
            </ul>
          </div>

          <div className="menu-login ">
            {!isLoggedIn ? (
              <button
                className="login-signup-btn"
                onClick={() => {
                  setloginModalVisible(true);
                }}
              >
                Login
              </button>
            ) : (
              <Dropdown
                className="profile-dropdown"
                placement="bottomLeft"
                overlayStyle={{
                  backgroundColor: "rgba(10, 3, 33, 1)",
                  borderRadius: 10,
                  width: 270,
                  padding: 15,
                }}
                dropdownRender={(res) => {
                  return (
                    <div className="menuDrop">
                      {res.props.items.map((list) => {
                        return (
                          <span
                            key={list.label}
                            style={{
                              color: "#fff",
                              fontFamily: "Poppins-Regular",
                              fontSize: 16,
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                            onClick={list.click}
                          >
                            <div style={{ marginRight: 10, display: "flex" }}>
                              {list.icon}
                            </div>
                            {list.label}
                          </span>
                        );
                      })}
                    </div>
                  );
                }}
                menu={{ items }}
              >
                <a className="pointer" onClick={(e) => e.preventDefault()}>
                  <img
                    style={{ borderRadius: 100 }}
                    src={
                      profileDetails?.profileUrl
                        ? profileDetails?.profileUrl
                        : avatar
                    }
                    className="profile-avatar"
                    alt="avatar"
                  />
                </a>
              </Dropdown>
            )}
          </div>

          <div className="hamburger-menu" onClick={toggleMenu}>
            <SvgHamburger />
          </div>
        </div>
      </nav>

      <Drawer
        className={"drawer-style"}
        width={"80%"}
        placement={"right"}
        closable={false}
        onClose={toggleMenu}
        open={menuVisible}
        key={"right"}
        style={{ overflow: "scroll", height: "100%" }}
      >
        <div className="menu-bar">
          <div className="menu-list-small">
            <div
              className="menu-close-icon"
              onClick={() => {
                scrollTop();
                toggleMenu();
              }}
            >
              <img src={closeIcon} alt="close-icon" />
            </div>

            {!isLoggedIn ? (
              <div className="menu-login-btn">
                <button
                  className="login-signup-btn "
                  onClick={() => {
                    toggleMenu();
                    setloginModalVisible(true);
                  }}
                >
                  Login
                </button>
              </div>
            ) : (
              <div className="menu-profile">
                <div className="menu-profile-avatar">
                  {" "}
                  <img
                    style={{ borderRadius: 100 }}
                    src={
                      profileDetails?.profileUrl
                        ? profileDetails?.profileUrl
                        : avatar
                    }
                    alt="avatar"
                  />
                </div>
                <p>{JSON.parse(getUserData)?.data?.userName}</p>
                <p>{JSON.parse(getUserData)?.data?.mobileNo}</p>
              </div>
            )}

            <ul>
              <li
                onClick={() => {
                  navigate("/");
                }}
              >
                <SvgHome />
                Home
              </li>
              <li
                onClick={() => {
                  navigate("/about");
                  toggleMenu();
                }}
              >
                <SvgAbout />
                About
              </li>
              <li
                onClick={() => setMenuList(!menuList)}
                className="pos-relative"
              >
                <SvgOurInsights />
                Our Insights
                <img
                  src={menuList ? downArrow : rightArrow}
                  className="insight-arrow"
                  alt="arrow"
                />
              </li>

              {menuList && (
                <li>
                  <ul>
                    {InsightsList.map((item) => (
                      <li
                        key={item.id}
                        onClick={() => {
                          navigate(item.path);
                          toggleMenu();
                        }}
                        style={{ fontWeight: "500" }}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
              <li
                onClick={() => {
                  navigate("/blogs");
                  toggleMenu();
                }}
              >
                <SvgBlogs />
                Blogs
              </li>
              <li
                onClick={() => {
                  navigate("/consult-astrology");
                  toggleMenu();
                }}
              >
                <SvgConsultWithAstrologers />
                Consult With Astrologers
              </li>

              <li
                onClick={() => {
                  navigate("/kundali");
                  toggleMenu();
                }}
              >
                <SvgKidsKundali />
                Kids Kundli
              </li>

              {isLoggedIn && (
                <li
                  onClick={() => {
                    navigate("/edit-profile");
                    toggleMenu();
                  }}
                >
                  <SvgEditProfile />
                  Edit Profile
                </li>
              )}
              {isLoggedIn && (
                <li
                  onClick={() => {
                    navigate("/wallet");
                    toggleMenu();
                  }}
                >
                  <SvgWallet />
                  Wallet
                </li>
              )}
              {isLoggedIn && (
                <li
                  onClick={() => {
                    navigate("/notifications");
                    toggleMenu();
                  }}
                >
                  <SvgNotifications />
                  Notifications
                </li>
              )}
              {isLoggedIn && (
                <li
                  onClick={() => {
                    navigate("/delete-account");
                    toggleMenu();
                  }}
                >
                  <SvgDeleteAccount />
                  Delete Account
                </li>
              )}
              {isLoggedIn && (
                <li
                  onClick={() => {
                    localStorage.clear();
                    navigate("/");
                    toggleMenu();
                  }}
                >
                  <SvgLogout />
                  Logout
                </li>
              )}
            </ul>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default connect(mapStateToProps)(TopBar);
